import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Id of the "Pending count review warning" setting row
 * (organisation_setting.settingId). Matched by id at Aaron's direction, same
 * approach as the sibling use-signature-required hook — note that hook's own
 * comment says a hard-coded id only works for rows old enough to predate the
 * per-environment split; this row was added by hand, so double-check id 10
 * actually resolves in QA/production before relying on it there too.
 */
const SETTING_ID = 10;

/** Only a deliberate "off" turns the warning off; anything else leaves it on. */
const OFF_VALUES = ["0", "false", "no", "off"];

/**
 * Use Pending Count Warning Enabled Hook
 *
 * Whether to warn the controller that an audit is still being counted — the
 * banner on the review screen and the acknowledgement asked for on approval.
 *
 * On by default. Reviewing during Pending Count is always available; this only
 * governs whether we caution the controller while they do it, so an organisation
 * that has never heard of the setting still gets the warning, and turning it off
 * has to be deliberate.
 */
export default () => {
    // typesList is empty until the lookup call lands, so this has to cope with
    // being asked before the settings exist rather than throwing on first render.
    const { organisationSettings } = useSelector((state) => state.typesList) ?? {};

    return useMemo(() => {
        const organisationSetting = (organisationSettings?.data ?? []).find(
            (item) => item.settingId === SETTING_ID
        );
        // Organisation has expressed no preference — warn.
        if (!organisationSetting) return true;

        const value = String(organisationSetting.value).trim().toLowerCase();
        return !OFF_VALUES.includes(value);
    }, [organisationSettings]);
};
